<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'GSLogout',
  methods: {
    ...mapActions('loginGeneral', ['doLogout']),
    async logout() {
      try {
        await this.doLogout({ isGS2Logout: true });
      } catch (e) {
        throw new Error(e);
      }
    },
  },
  mounted() {
    this.logout();
    this.$router.replace({ name: 'viewAll' });
  },
};
</script>
